export const COLORS_ATTRIBUTE = 'data-branding-colors';
